import {Component, Inject, OnInit, Optional} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {take} from "rxjs/operators";
import {ChartServiceData} from "../../../services/chart.service";
import {ComboEchartComponent} from "../combo-echart/combo-echart.component";
import {NgOptimizedImage} from "@angular/common";

interface ChartModalData {
  serviceData: ChartServiceData;
}

@Component({
  selector: "app-chart-modal",
  templateUrl: "./chart-modal.component.html",
  styleUrls: ["./chart-modal.component.css"],
  imports: [ComboEchartComponent, NgOptimizedImage]
})
export class ChartModalComponent implements OnInit {
  destroyChart: boolean = false;
  showCloseButton: boolean = false;
  serviceData!: ChartServiceData;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ChartModalData,
    private dialogRef: MatDialogRef<ChartModalComponent>,
  ) {
    if (data?.serviceData) {
      this.serviceData = data.serviceData;
    } else {
      console.warn("ServiceData missing or wrong structure", data);
    }
  }

  ngOnInit(): void {
    this.dialogRef.beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        this.destroyChart = true;
      });
  }

  onClose() {
    this.dialogRef.close();
  }

  onShowCloseButton() {
    this.showCloseButton = true;
  }
}
